import type { ComponentType } from "react";
import { getCurrentCountryCode } from "@/utils/countryConfigUtils";
import FlatRechargeDefault from "@/pages/wallet/recharge/flat/variants/FlatRechargeDefault";
import FlatRechargeAuthorize from "@/pages/wallet/recharge/flat/variants/FlatRechargeAuthorize";
import FlatRechargeWarning from "@/pages/wallet/recharge/flat/variants/FlatRechargeWarning";
import FlatRechargeKenya from "@/pages/wallet/recharge/flat/variants/FlatRechargeKenya";
import FlatRechargeTanzania from "@/pages/wallet/recharge/flat/variants/FlatRechargeTanzania";
import FlatRechargeGhana from "@/pages/wallet/recharge/flat/variants/FlatRechargeGhana";
import FlatRechargeZambia from "@/pages/wallet/recharge/flat/variants/FlatRechargeZambia";
import FlatRechargeMexico from "@/pages/wallet/recharge/flat/variants/FlatRechargeMexico";
import FlatWithdrawDefault from "@/pages/wallet/withdraw/flat/variants/FlatWithdrawDefault";
import FlatWithdrawEgypt from "@/pages/wallet/withdraw/flat/variants/FlatWithdrawEgypt";
import FlatWithdrawGhana from "@/pages/wallet/withdraw/flat/variants/FlatWithdrawGhana";
import FlatWithdrawNigeria from "@/pages/wallet/withdraw/flat/variants/FlatWithdrawNigeria";
import FlatWithdrawZambia from "@/pages/wallet/withdraw/flat/variants/FlatWithdrawZambia";
import FlatWithdrawKenya from "@/pages/wallet/withdraw/flat/variants/FlatWithdrawKenya";
import FlatWithdrawTanzania from "@/pages/wallet/withdraw/flat/variants/FlatWithdrawTanzania";
import FlatWithdrawMexico from "@/pages/wallet/withdraw/flat/variants/FlatWithdrawMexico";

const getWalletCountry = (): string => {
  return getCurrentCountryCode() || "ke";
};

const rechargeStrategyMap: Record<string, ComponentType> = {
  sn: FlatRechargeDefault,
  tg: FlatRechargeDefault,
  bj: FlatRechargeDefault,
  bf: FlatRechargeDefault,
  ci: FlatRechargeDefault,
  gh: FlatRechargeGhana,
  ng: FlatRechargeAuthorize,
  zm: FlatRechargeZambia,
  eg: FlatRechargeWarning,
  ke: FlatRechargeKenya,
  tz: FlatRechargeTanzania,
  dev: FlatRechargeKenya,
  mx: FlatRechargeMexico,
};

const withdrawStrategyMap: Record<string, ComponentType> = {
  sn: FlatWithdrawDefault,
  tg: FlatWithdrawDefault,
  bj: FlatWithdrawDefault,
  bf: FlatWithdrawDefault,
  ci: FlatWithdrawDefault,
  gh: FlatWithdrawGhana,
  ng: FlatWithdrawNigeria,
  zm: FlatWithdrawZambia,
  eg: FlatWithdrawEgypt,
  ke: FlatWithdrawKenya,
  tz: FlatWithdrawTanzania,
  dev: FlatWithdrawKenya,
  mx: FlatWithdrawMexico,
};

export const getWalletFlatRechargeComponent = (): ComponentType => {
  const country = getWalletCountry();
  return rechargeStrategyMap[country] || FlatRechargeDefault;
};

export const getWalletFlatWithdrawComponent = (): ComponentType => {
  const country = getWalletCountry();
  return withdrawStrategyMap[country] || FlatWithdrawDefault;
};

export const getWalletWithdrawMethodOptions = (): string[] => {
  const country = getWalletCountry();
  const methodMap: Record<string, string[]> = {
    sn: ["wave", "orange"],
    tg: ["tmoney", "moov"],
    bj: ["momo", "moov"],
    bf: ["orange", "moov"],
    ci: ["wave", "orange", "moov", "momo"],
  };
  return methodMap[country] || [];
};
